import { gql, TypedDocumentNode } from "@apollo/client";

import { Module, Version } from "types/generated";

type GetVersionInstructionData = {
  module: Pick<Module, "id" | "name" | "workflowTool" | "moduleSource"> & {
    version: Pick<Version, "id" | "metadata"> | null;
  };
};

export const GET_VERSION_INSTRUCTION: TypedDocumentNode<GetVersionInstructionData> = gql`
  query GetVersionInstruction($moduleId: ID!, $id: ID!) {
    module(id: $moduleId) {
      id
      moduleSource
      name
      workflowTool
      version(id: $id) {
        id
        metadata {
          root {
            inputs {
              name
              type
              description
              default
              required
            }
          }
        }
      }
    }
  }
`;
